import * as React from 'react';
import { connect } from 'react-redux';

import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import Icons from '../../../../common/designElements/Icons';
import { QuestionTypesMap } from '@nexxt/common/questionTypes';
import {
    QTYPES,
    Project,
    Question,
    QuestionSummary,
    RichTextContent,
    SPECIAL_QIDS
} from '@nexxt/common/types';
import store from '../../../../../store';
import { IApplicationState } from '../../../../../reducers';
import NotifyHOC from '../../../../../HOC/Notifications';
import RichTextTranslation from '../../../../common/richTextField/Readonly';
import HealthIcon from '../../../../common/designElements/HealthIcon';

interface RedirectCardProps {
    project: Project;
    search: string;
    currentQuestion: Partial<Question>;
    disabled: boolean;
    health: any;
    actions: {
        edit: (question: Partial<QuestionSummary>) => void;
        preview: (question: Partial<QuestionSummary>) => void;
    };
    onSelectQuestion: (question: Partial<QuestionSummary>) => void;
    initialSelectedQuestionID: number;
}

const RedirectCard: React.FunctionComponent<RedirectCardProps> = (
    props: RedirectCardProps
) => {
    // Responsible for scrolling to selected question on page load
    const scrollDiv = React.useRef(null);
    const { disabled } = props;
    let defaultRedirectText;
    try {
        const firstValidLanguageIndex =
            props.project?.redirectSettings?.redirects[0]?.multimediaTexts.findIndex(
                (multimediaText) =>
                    multimediaText?.language == props.project.languages[0].value
            );

        defaultRedirectText = (
            props.project?.redirectSettings?.redirects[0]?.multimediaTexts[
                firstValidLanguageIndex
            ].contents[0] as RichTextContent
        ).richText;
    } catch (err) {}
    React.useEffect(() => {
        if (props.initialSelectedQuestionID === -2) {
            // Scrolls to selected question on page load
            scrollDiv.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);
    return (
        <div
            className={classnames(`question-card`, {
                active:
                    props?.currentQuestion &&
                    props?.currentQuestion.type === QTYPES.REDIRECT,
                disabled
            })}
            onClick={() => {
                props.onSelectQuestion({ type: QTYPES.REDIRECT });
            }}
            ref={scrollDiv}
        >
            <div className="q-card-pre-header">
                <span
                    className="pre-header-icon"
                    data-tip="custom show"
                    data-for={`redirect`}
                >
                    <Icons type="greeting" width={25} />
                </span>
                <ReactTooltip
                    className="pre-header-tooltip"
                    id={`redirect`}
                    aria-haspopup="true"
                    effect="solid"
                    place="right"
                    arrowColor={'transparent'}
                >
                    <span>REDIRECT MESSAGE</span>
                </ReactTooltip>
            </div>
            <div className="q-card-header">
                <span className="question-image">
                    <img src={QuestionTypesMap[QTYPES.REDIRECT].image} />
                </span>
                <span className="question-label">
                    {props.project?.redirectSettings?.label || 'Redirect Text'}
                </span>
                <HealthIcon
                    questionID={SPECIAL_QIDS.REDIRECT_TEXT}
                    active={!!props.health}
                    type={props.health?.type}
                    className={`health ${props.health?.type?.toLowerCase()}`}
                    message={props.health && props.health.list[0].message}
                />
            </div>
            <div className="q-card-body">
                <div className="card-content">
                    {props.project.redirectSettings && (
                        <RichTextTranslation value={defaultRedirectText} />
                    )}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (store: IApplicationState) => {
    const {
        questionReducer: { currentQuestion },
        projectReducer: { currentProject }
    } = store;

    return { project: currentProject, currentQuestion };
};

export default NotifyHOC(connect(mapStateToProps, null)(RedirectCard));
